(() => {
  const DRAWER_SELECTOR = '[data-wb-sub-benefits-drawer]';
  const TRIGGER_SELECTOR = '[data-wb-sub-benefits-open]';
  const CLOSE_SELECTOR = '[data-wb-sub-benefits-close]';
  const OPEN_CLASS = 'is-open';
  const CLOSE_DELAY = 260;

  const state = {
    drawer: null,
    overlay: null,
    trigger: null,
  };

  const getOverlayForDrawer = (drawerId) =>
    document.querySelector(`.wb-sub-benefits__overlay[data-wb-sub-benefits-target="${drawerId}"]`);

  const getTriggersForDrawer = (drawerId) =>
    Array.from(document.querySelectorAll(`${TRIGGER_SELECTOR}[data-wb-sub-benefits-target="${drawerId}"]`));

  const setTriggerExpanded = (drawerId, expanded) => {
    getTriggersForDrawer(drawerId).forEach((trigger) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const showElement = (el) => {
    if (!el) return;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
  };

  const hideElement = (el) => {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
  };

  const clearBodyLock = () => {
    document.body.classList.remove('wb-sub-benefits-open');
    if (!document.body.classList.contains('wb-quick-add-open')) {
      document.body.classList.remove('overflow-hidden');
    }
  };

  const bindSwipeClose = (drawer) => {
    if (drawer.dataset.wbSwipeBound === 'true') return;
    drawer.dataset.wbSwipeBound = 'true';

    let startX = 0;
    let startY = 0;

    drawer.addEventListener(
      'touchstart',
      (e) => {
        const t = e.changedTouches[0];
        startX = t.clientX;
        startY = t.clientY;
      },
      { passive: true }
    );

    drawer.addEventListener(
      'touchend',
      (e) => {
        if (!drawer.classList.contains(OPEN_CLASS)) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - startX;
        const dy = Math.abs(t.clientY - startY);

        if (dx > 70 && dy < 40) closeDrawer();
      },
      { passive: true }
    );
  };

  const mountDrawersToBody = () => {
    if (!document.body) return;

    document.querySelectorAll(DRAWER_SELECTOR).forEach((drawer) => {
      if (!(drawer instanceof HTMLElement)) return;
      const drawerId = drawer.getAttribute('id');
      if (!drawerId) return;

      const overlay = getOverlayForDrawer(drawerId);
      if (!(overlay instanceof HTMLElement)) return;

      if (drawer.dataset.wbSubBenefitsMounted !== 'true') {
        const portal = document.createElement('div');
        portal.className = 'wb-sub-benefits__portal';
        portal.dataset.wbSubBenefitsPortal = drawerId;
        portal.appendChild(overlay);
        portal.appendChild(drawer);
        document.body.appendChild(portal);

        drawer.dataset.wbSubBenefitsMounted = 'true';
      }

      drawer.classList.remove(OPEN_CLASS);
      overlay.classList.remove(OPEN_CLASS);
      hideElement(drawer);
      hideElement(overlay);
      setTriggerExpanded(drawerId, false);
      bindSwipeClose(drawer);
    });
  };

  const closeDrawer = () => {
    if (!state.drawer) return;

    const drawer = state.drawer;
    const overlay = state.overlay;
    const drawerId = drawer.getAttribute('id');

    drawer.classList.remove(OPEN_CLASS);
    if (overlay) overlay.classList.remove(OPEN_CLASS);

    setTriggerExpanded(drawerId, false);
    clearBodyLock();

    window.setTimeout(() => {
      hideElement(drawer);
      hideElement(overlay);
    }, CLOSE_DELAY);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(state.trigger || null);
    } else if (state.trigger && typeof state.trigger.focus === 'function') {
      state.trigger.focus();
    }

    state.drawer = null;
    state.overlay = null;
    state.trigger = null;
  };

  const openDrawer = (drawer, trigger) => {
    if (!(drawer instanceof HTMLElement)) return;
    const drawerId = drawer.getAttribute('id');
    if (!drawerId) return;

    const overlay = getOverlayForDrawer(drawerId);
    if (!(overlay instanceof HTMLElement)) return;

    if (state.drawer && state.drawer !== drawer) closeDrawer();

    state.drawer = drawer;
    state.overlay = overlay;
    state.trigger = trigger || null;

    showElement(drawer);
    showElement(overlay);

    requestAnimationFrame(() => {
      drawer.classList.add(OPEN_CLASS);
      overlay.classList.add(OPEN_CLASS);
    });

    setTriggerExpanded(drawerId, true);

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('wb-sub-benefits-open');

    if (typeof trapFocus === 'function') {
      const focusTarget = drawer.querySelector(CLOSE_SELECTOR) || drawer;
      trapFocus(drawer, focusTarget);
    } else {
      drawer.focus();
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const openButton = event.target.closest(TRIGGER_SELECTOR);
      if (openButton) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        const drawerId = openButton.getAttribute('data-wb-sub-benefits-target');
        if (!drawerId) return;

        const drawer = document.getElementById(drawerId);
        openDrawer(drawer, openButton);
        return;
      }

      if (event.target.closest(CLOSE_SELECTOR)) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (state.drawer && state.drawer.classList.contains(OPEN_CLASS)) {
        const insideDrawer = event.target.closest('.wb-sub-benefits__drawer');
        const onTrigger = event.target.closest(TRIGGER_SELECTOR);
        if (!insideDrawer && !onTrigger) closeDrawer();
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDrawersToBody, { once: true });
  } else {
    mountDrawersToBody();
  }

  document.addEventListener('shopify:section:load', mountDrawersToBody);
  document.addEventListener('shopify:section:reorder', mountDrawersToBody);

  window.WBSubscriptionBenefitsDrawer = {
    remount: mountDrawersToBody,
    openById: (drawerId) => openDrawer(document.getElementById(drawerId), null),
    close: closeDrawer,
  };
})();
